<template>
  <v-dialog
    :value="value"
    max-width="520"
    persistent
    content-class="bundle_assign_dialog"
    @input="$emit('input', $event)"
  >
    <v-card class="bundle_dialog bundle_dialog--assign">
      <div class="bundle_dialog__title">
        <div class="bundle_dialog__title_text">
          <i class="fal fa-user-plus"></i>
          <span>{{ $t("TITLES.assign_driver") }}</span>
        </div>
        <button type="button" class="bundle_dialog__close" @click="$emit('input', false)">
          <i class="fal fa-times"></i>
        </button>
      </div>

      <div class="bundle_dialog__body">
        <p class="bundle_dialog__hint">{{ $t("MESSAGES.assign_driver_msg") }}</p>

        <div class="driver_select_field driver-select">
          <base-select-input
            :optionsList="drivers"
            :placeholder="$t('PLACEHOLDERS.driver_name')"
            :value="selectedDriver"
            :loading="driversLoading"
            @input="$emit('update:selectedDriver', $event)"
            @search-change="$emit('driver-search', $event)"
            @open="$emit('driver-open')"
          />
        </div>
      </div>

      <div class="bundle_dialog__actions">
        <v-btn text @click="$emit('input', false)">
          {{ $t("BUTTONS.cancel") }}
        </v-btn>
        <v-btn
          color="primary"
          depressed
          :loading="loading"
          :disabled="!selectedDriver || loading"
          @click="$emit('confirm')"
        >
          <i class="fal fa-check mr-1"></i>
          {{ $t("BUTTONS.confirm") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "BundleAssignDriverDialog",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    drivers: {
      type: Array,
      default: () => [],
    },
    selectedDriver: {
      type: Object,
      default: null,
    },
    driversLoading: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
